// import React from "react";
// import TextField from "@material-ui/core/TextField";

// /**
//  * Returns material-ui TextField component with attributes passed in from parent. Used as a solution to allow Material-UI [TextField]{@link https://material-ui.com/components/text-fields/} with Formik
//  * @module TextFieldFormik
//  */
// const MaterialInput = ({
//   field: { /* value, */ ...fields },
//   form: { touched, errors, ...rest },
//   ...props
//   }) => {
//   return (
//     <TextField
//       {...props}
//       {...fields}
//     />
//   );
// };

// export default MaterialInput;

// VERSION 2

import React from "react";
import TextField from "@material-ui/core/TextField";
import clsx from "clsx";

// /**
//  * Material UI TextField component wired up with Formik
//  */
// const MaterialInput = ({
//   field: { name, value, onChange, onBlur },
//   form: { touched, errors },
//   ...props
// }) => {
//   const showError = touched[name] && Boolean(errors[name]);

//   return (
//     <TextField
//       name={name}
//       value={value}
//       onChange={(e) => {
//         console.log(e.target.value); // 👈 custom logic
//         onChange(e);                 // 👈 Formik must stay in sync
//       }}
//       onBlur={onBlur}
//     //   error={showError}
//     //   helperText={showError ? errors[name] : ""}
//       {...props}
//     />
//   );
// };

// export default MaterialInput;

const MaterialInput = ({
  field: { name, value, onChange, onBlur },
  form: { touched, errors },
  ...props
}) => {
  const showError = touched[name] && Boolean(errors[name]);

  return (
    <TextField
      name={name}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      label={props.label}
      error={showError}
      InputProps={{
        ...props.InputProps,
        className: clsx("standardInput", { errorInput: showError }),
        inputProps: {
          ...props.InputProps?.inputProps,
          className: clsx("standardInput", { errorInput: showError }),
        },
      }}
      FormControlProps={{
        ...props.FormControlProps,
        className: clsx(props.FormControlProps?.className, {
          errorInput: showError,
        }),
      }}
      {...props}
    />
  );
};

export default MaterialInput;
